export default "__VITE_ASSET__d82c5ab1__"